import { WebPaymentDto } from './web-payment.dto';
import { WebPaymentTypeEnum, PaymentMethodEnum } from '../enum';

export class WebPaymentRequestDto {
  webPaymentType: WebPaymentTypeEnum;
  webPaymentCode?: string;
  referenceId?: number;
  webPayment?: WebPaymentDto;
  paymentMethodId?: PaymentMethodEnum;
  /** Bank MID ID, optional for billing */
  bankMIDId?: number;
}
